function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calendar_Canvas",
  transform: "translate(-1449 -1179)"
}, /*#__PURE__*/React.createElement("g", {
  id: "calendar_calendar"
}, /*#__PURE__*/React.createElement("g", {
  id: "calendar_Path 190"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path0_fill",
  transform: "translate(1449 1179)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Path 191"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path1_fill",
  transform: "translate(1470.92 1179)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Path 192"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path2_fill",
  transform: "translate(1476.19 1179)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 268"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1467.42 1199.18)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 269"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1473.56 1199.18)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 270"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1479.7 1199.18)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 271"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1485.84 1199.18)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 272"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1491.98 1199.18)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 273"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1455.14 1206.2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 274"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1461.28 1206.2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 275"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1467.42 1206.2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 276"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1473.56 1206.2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 277"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1479.7 1206.2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 278"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1485.84 1206.2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 279"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1491.98 1206.2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 280"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1455.14 1212.34)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 281"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1461.28 1212.34)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 282"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1467.42 1212.34)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 283"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1473.56 1212.34)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 284"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1479.7 1212.34)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 285"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1485.84 1212.34)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 286"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1491.98 1212.34)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 287"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1455.14 1219.35)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 288"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1461.28 1219.35)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 289"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1467.42 1219.35)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 290"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1473.56 1219.35)"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar_Ellipse 291"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calendar_path3_fill",
  transform: "translate(1479.7 1219.35)"
}))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "calendar_path0_fill",
  d: "M 37.629 3.508C 37.4261 2.51887 36.8885 1.6299 36.1067 0.990908C 35.3249 0.351913 34.3467 0.0019522 33.337 9.53674e-08C 33.1051 9.53674e-08 32.8826 0.0921345 32.7186 0.256135C 32.5546 0.420136 32.4625 0.642568 32.4625 0.8745C 32.4625 1.10643 32.5546 1.32886 32.7186 1.49286C 32.8826 1.65687 33.1051 1.749 33.337 1.749C 34.0353 1.75033 34.7045 2.029 35.1973 2.52372C 35.6902 3.01844 35.9663 3.68868 35.965 4.387C 35.9637 5.08531 35.685 5.7545 35.1903 6.24735C 34.6956 6.74019 34.0253 7.01633 33.327 7.015C 33.0951 7.015 32.8726 7.10713 32.7086 7.27113C 32.5446 7.43514 32.4525 7.65757 32.4525 7.8895C 32.4525 8.12143 32.5446 8.34386 32.7086 8.50786C 32.8726 8.67187 33.0951 8.764 33.327 8.764C 34.3369 8.76228 35.3153 8.41242 36.0973 7.77341C 36.8793 7.13439 37.4171 6.2453 37.62 5.256L 49.12 5.256L 49.12 13.146L 1.759 13.146L 1.759 5.266L 16.673 5.266C 16.9049 5.266 17.1274 5.17386 17.2914 5.00986C 17.4554 4.84586 17.5475 4.62343 17.5475 4.3915C 17.5475 4.15957 17.4554 3.93714 17.2914 3.77313C 17.1274 3.60913 16.9049 3.517 16.673 3.517L 15.083 3.517C 15.2431 3.06173 15.5256 2.65935 15.8993 2.35398C 16.273 2.04862 16.7236 1.85207 17.2017 1.78588C 17.6797 1.71969 18.1668 1.78642 18.6094 1.97875C 19.052 2.17108 19.4332 2.48159 19.711 2.87622C 19.9888 3.27085 20.1526 3.73437 20.1844 4.21593C 20.2162 4.6975 20.1147 5.17852 19.8912 5.60625C 19.6677 6.03398 19.3307 6.39189 18.9172 6.64074C 18.5037 6.8896 18.0296 7.01977 17.547 7.017C 17.3151 7.017 17.0926 7.10913 16.9286 7.27313C 16.7646 7.43714 16.6725 7.65957 16.6725 7.8915C 16.6725 8.12343 16.7646 8.34586 16.9286 8.50986C 17.0926 8.67387 17.3151 8.766 17.547 8.766C 18.3763 8.76618 19.1886 8.53104 19.8895 8.0879C 20.5905 7.64476 21.1513 7.01181 21.5068 6.2626C 21.8624 5.51339 21.998 4.67868 21.898 3.85545C 21.7979 3.03222 21.4664 2.25427 20.9418 1.612C 20.4172 0.96973 19.7211 0.489504 18.9344 0.22712C 18.1477 -0.0352646 17.3027 -0.0690335 16.4976 0.129737C 15.6925 0.328507 14.9603 0.751655 14.3862 1.35001C 13.812 1.94837 13.4194 2.69738 13.254 3.51L 0 3.51L 0 50L 50.874 50L 50.874 3.508L 37.629 3.508ZM 49.116 48.241L 1.759 48.241L 1.759 14.915L 49.126 14.915L 49.126 48.241L 49.116 48.241Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "calendar_path1_fill",
  d: "M 0.879505 1.759C 1.22462 1.759 1.56635 1.82698 1.8852 1.95904C 2.20404 2.09111 2.49375 2.28469 2.73778 2.52872C 2.98181 2.77276 3.17538 3.06246 3.30745 3.38131C 3.43952 3.70015 3.5075 4.04189 3.5075 4.387C 3.5075 4.73211 3.43952 5.07385 3.30745 5.39269C 3.17538 5.71154 2.98181 6.00124 2.73778 6.24528C 2.49375 6.48931 2.20404 6.68289 1.8852 6.81496C 1.56635 6.94702 1.22462 7.015 0.879505 7.015C 0.647573 7.015 0.425143 7.10713 0.261143 7.27113C 0.0971421 7.43514 0.00499341 7.65757 0.00499341 7.8895C 0.00499341 8.12143 0.0971421 8.34386 0.261143 8.50786C 0.425143 8.67187 0.647573 8.764 0.879505 8.764C 1.45496 8.764 2.02477 8.65066 2.55642 8.43044C 3.08806 8.21023 3.57114 7.88745 3.97805 7.48054C 4.38495 7.07364 4.70772 6.59057 4.92794 6.05892C 5.14815 5.52727 5.26149 4.95745 5.26149 4.382C 5.26149 3.80655 5.14815 3.23673 4.92794 2.70508C 4.70772 2.17343 4.38495 1.69036 3.97805 1.28346C 3.57114 0.876552 3.08806 0.553776 2.55642 0.33356C 2.02477 0.113344 1.45496 8.67925e-08 0.879505 9.53674e-08C 0.646247 9.53674e-08 0.422541 0.0926612 0.257603 0.257599C 0.0926644 0.422538 3.78418e-06 0.646242 3.78418e-06 0.8795C 3.78418e-06 1.11276 0.0926644 1.33646 0.257603 1.5014C 0.422541 1.66634 0.646247 1.759 0.879505 1.759Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "calendar_path2_fill",
  d: "M 0.879505 1.759C 1.22462 1.759 1.56634 1.82698 1.88518 1.95904C 2.20403 2.09111 2.49375 2.28469 2.73778 2.52872C 2.98181 2.77276 3.17538 3.06246 3.30745 3.38131C 3.43952 3.70015 3.5075 4.04189 3.5075 4.387C 3.5075 4.73211 3.43952 5.07385 3.30745 5.39269C 3.17538 5.71154 2.98181 6.00124 2.73778 6.24528C 2.49375 6.48931 2.20403 6.68289 1.88518 6.81496C 1.56634 6.94702 1.22462 7.015 0.879505 7.015C 0.647573 7.015 0.425128 7.10713 0.261127 7.27113C 0.0971269 7.43514 0.00499341 7.65757 0.00499341 7.8895C 0.00499341 8.12143 0.0971269 8.34386 0.261127 8.50786C 0.425128 8.67187 0.647573 8.764 0.879505 8.764C 1.45496 8.764 2.02477 8.65066 2.55642 8.43044C 3.08806 8.21023 3.57114 7.88745 3.97805 7.48054C 4.38495 7.07364 4.70772 6.59057 4.92794 6.05892C 5.14815 5.52727 5.26149 4.95745 5.26149 4.382C 5.26149 3.80655 5.14815 3.23673 4.92794 2.70508C 4.70772 2.17343 4.38495 1.69036 3.97805 1.28346C 3.57114 0.876552 3.08806 0.553776 2.55642 0.33356C 2.02477 0.113344 1.45496 8.67925e-08 0.879505 9.53674e-08C 0.646247 9.53674e-08 0.422526 0.0926612 0.257587 0.257599C 0.0926492 0.422538 -1.14746e-05 0.646242 -1.14746e-05 0.8795C -1.14746e-05 1.11276 0.0926492 1.33646 0.257587 1.5014C 0.422526 1.66634 0.646247 1.759 0.879505 1.759Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "calendar_path3_fill",
  d: "M 0.874 1.748C 1.3567 1.748 1.748 1.3567 1.748 0.874C 1.748 0.391303 1.3567 0 0.874 0C 0.391303 0 0 0.391303 0 0.874C 0 1.3567 0.391303 1.748 0.874 1.748Z"
}));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e2167a48.svg";
export { ForwardRef as ReactComponent };